import React, { useContext } from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { MiwaAppWebsocketContext } from '@/contexts/miwa-app-websocket'
import { TMiwaAppWebsocketContext } from '@/models/miwa-lock'

type Props = {
  id: string
}

/**
 * 美和アプリへ接続する PCID の入力欄。値は接続情報と同じく Provider が保持する
 */
export const MiwaPcidInput: React.FC<Props> = ({ id }) => {
  const { t } = useTranslation()
  const { miwaAppWebsocketPCID, setMiwaAppWebsocketPCID } = useContext<TMiwaAppWebsocketContext>(MiwaAppWebsocketContext)

  return (
    <div>
      <label htmlFor={id} css={labelStyle}>
        {t('PCID')}
      </label>
      <input id={id} type="text" css={inputStyle} value={miwaAppWebsocketPCID} onChange={e => setMiwaAppWebsocketPCID(e.target.value)} />
    </div>
  )
}

const labelStyle = css({
  display: 'block',
  color: '#676767',
  fontSize: 14,
  fontWeight: 'bold',
  letterSpacing: 0.7,
  marginBottom: 12,
})

const inputStyle = css({
  width: '100%',
  height: 32,
  padding: '0 16px',
  border: '1px solid #CCCCCC',
  borderRadius: 16,
  fontSize: 14,
  color: '#272727',
})
